var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"font-weight-bold mr-2"},[_vm._v(_vm._s(_vm.value)+"/"+_vm._s(_vm.maxValue))]),_vm._v(" "),_c('div',{staticClass:"scale-bars d-flex"},_vm._l((_vm.maxValue),function(i){return _c('div',{key:i,staticClass:"scale-bar",class:{ filled: i <= _vm.value }})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }